import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { DropInPayments } from '@chegg/dropin-payments';
import { getDipCallback } from './helpers';
import { useQuery } from '@apollo/client';
import { initApolloClient } from '../../lib/ApolloSchema/apolloUtils';
import { GET_APOLLO_STATE } from '../../lib/Graphql/getApolloState';
import { DIP_WRAPPER_TESTID, PaymentMethods } from './constants';
var Yiftee = PaymentMethods.Yiftee,
  CreditCard = PaymentMethods.CreditCard,
  ApplePay = PaymentMethods.ApplePay,
  PayPal = PaymentMethods.PayPal,
  Venmo = PaymentMethods.Venmo,
  GooglePay = PaymentMethods.GooglePay;
var DropInPaymentsWrapper = function DropInPaymentsWrapper(_ref) {
  var country = _ref.country,
    authorization = _ref.authorization,
    withCoupon = _ref.withCoupon,
    content = _ref.content,
    paymentForm = _ref.paymentForm,
    paymentErrorModal = _ref.paymentErrorModal,
    commands = _ref.commands,
    showHeading = _ref.showHeading,
    headingText = _ref.headingText,
    externalId = _ref.externalId,
    namespace = _ref.namespace,
    uvn = _ref.uvn,
    userUuid = _ref.userUuid,
    environment = _ref.environment,
    reviewStepEnabled = _ref.reviewStepEnabled,
    userAction = _ref.userAction,
    optimizelyClient = _ref.optimizelyClient,
    referrer = _ref.referrer,
    useForter = _ref.useForter,
    taxInfo = _ref.taxInfo,
    venmoVisible = _ref.venmoVisible,
    googlepayVisible = _ref.googlepayVisible,
    couponCode = _ref.couponCode,
    recurlyCart = _ref.recurlyCart,
    isRecurly = _ref.isRecurly;
  var client = initApolloClient();
  var _useQuery = useQuery(GET_APOLLO_STATE, {
      client: client
    }),
    apolloState = _useQuery.data;
  var _ref2 = apolloState,
    uiData = _ref2.uiData;
  var newUserNoMop = uiData.newUserNoMop,
    showOnlyPM = uiData.showOnlyPM;
  var props = {
    config: {
      authorization: authorization,
      country: country,
      withCoupon: withCoupon,
      content: content,
      paymentForm: paymentForm,
      showHeading: showHeading,
      headingText: headingText,
      ui: {
        displayServerErrors: false,
        showSubmitButton: !newUserNoMop //show add card button for no MOP use cases
      },

      paymentMethods: [CreditCard, ApplePay, PayPal, Yiftee, Venmo, GooglePay],
      venmoVisible: venmoVisible,
      googlepayVisible: googlepayVisible,
      rioNamespace: namespace,
      fireRioPurchaseEvent: true,
      environment: environment,
      userUuid: userUuid,
      userAction: userAction,
      uvn: uvn,
      referrer: referrer,
      useForter: useForter,
      couponCode: couponCode,
      isRecurly: isRecurly,
      recurlyCart: recurlyCart,
      displayOrderSummary: !showOnlyPM
    },
    review: {
      currentStep: apolloState === null || apolloState === void 0 ? void 0 : apolloState.reviewData.currentStep,
      reviewStepEnabled: reviewStepEnabled,
      intlCountries: ['CA']
    },
    callback: getDipCallback(externalId, userAction, _objectSpread(_objectSpread({}, uiData), {}, {
      paymentErrors: paymentErrorModal === null || paymentErrorModal === void 0 ? void 0 : paymentErrorModal.serverErrors
    })),
    commands: commands,
    optimizelyClient: optimizelyClient,
    taxInfo: taxInfo
  };

  // delay rendering of DIP until Recurly cart is ready
  if (isRecurly && !recurlyCart) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-test": DIP_WRAPPER_TESTID
  }, /*#__PURE__*/React.createElement(DropInPayments, props));
};
export default DropInPaymentsWrapper;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/modules/DropInPayments/index.js
// module id = 4362
// module chunks = 11